var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsBulkMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.021,
    height: 22.917,
    viewBox: "0 0 23.021 22.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Message",
    transform: "translate(-610.432 -654.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chatbubbles-outline",
    transform: "translate(611.035 655.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M132.88,62.362a.965.965,0,0,1,.174-.643,1.775,1.775,0,0,1,.111-.163,8.535,8.535,0,0,0,1.454-4.758,8.962,8.962,0,0,0-9.152-8.8,9.088,9.088,0,0,0-8.972,7,8.466,8.466,0,0,0-.195,1.8,8.937,8.937,0,0,0,9.009,8.909,10.85,10.85,0,0,0,2.487-.406c.6-.163,1.185-.379,1.338-.437a1.393,1.393,0,0,1,.49-.09,1.37,1.37,0,0,1,.532.105l2.987,1.059a.712.712,0,0,0,.205.053.421.421,0,0,0,.421-.421.675.675,0,0,0-.026-.142Z",
    transform: "translate(-112.702 -48)",
    fill: "none",
    stroke: "#3e5172",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M48.972,232a7.7,7.7,0,0,0,.337,8.044c.122.184.19.326.169.421s-.629,3.26-.629,3.26a.421.421,0,0,0,.143.4.43.43,0,0,0,.272.094.383.383,0,0,0,.153-.032l2.961-1.159a.827.827,0,0,1,.632.011,8.924,8.924,0,0,0,3.2.632,8.388,8.388,0,0,0,4.217-1.132",
    transform: "translate(-47.999 -222.306)",
    fill: "none",
    stroke: "#3e5172",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsBulkMessageIcon);
export default __webpack_public_path__ + "static/media/settings-bulk-message-icon.6954e462270fbb1bb557a34b0f1d713b.svg";
export { ForwardRef as ReactComponent };